import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';
import { FC, ReactNode, cloneElement, useEffect } from 'react';

const LazyPopup = dynamic(() => import('./LazyPopup'), { ssr: false });

type Props = {
  className?: string;
  isShow?: boolean;
  isSupportTabBar?: boolean;
  onCancel?: (back?) => void;
  onFocus?: (e?) => void;
  onSearch?: (keyword?: string, trigger_type?: string) => void;
  moduleName?: string;
  children?: ReactNode;
  routerUrl?: string;
  /** 是否支持热词 */
  isSupportHotKeyword?: boolean;
  /** 是否支持联想 */
  isSupportAssoation?: boolean;
  /** 是否支持曾经购买 */
  isSupportBought?: boolean;
  /** 是否展示历史记录 */
  hasHistory?: boolean;
  /** 是否添加识别触发方式 */
  isTriggerType?: boolean;
  /** \<input />是否自动获取焦点 默认值为 true */
  inputAutoFocus?: boolean;
  placeholder?: any;
  /** 如果是在vendor 首页搜索 需要知道vendor id */
  vendorId?: number;
  vendorTitle?: string;
  focusChange?: (focus: boolean) => void;
  isInGroupOrder?: boolean;
  showMiniCart?: boolean;
  handleToCart?: (e) => void;
  shareInfo?: any;
  fromDrawer?: boolean;
  popupProps?: ObjectType;
  bodyFixed?: boolean;
  /**
   * 是否预加载(在客户端预加载)
   * 为了提高页面INP，对一些使用几率高的懒加载组件进行预加载
   * 避免用户点击按钮后一段时间内页面无响应
   */
  isPreload?: boolean;
} & ObjectType;

const LazySearch: FC<Props> = props => {
  const { children, popupProps, isPreload } = props;
  const { visible, hide, show, loaded } = useLazy();

  const handleCancel = () => {
    hide();
  };

  useEffect(() => {
    if (isPreload) {
      import('./LazyPopup');
    }
  }, [isPreload]);

  return (
    <>
      {!!children &&
        cloneElement(children as any, {
          onClick: show
        })}

      {loaded ? (
        <LazyPopup visible={visible} onCancel={handleCancel} containerProps={props} popupProps={popupProps} />
      ) : null}
    </>
  );
};

export default LazySearch;
